// gatsby-plugin-offline was removed (see gatsby-config.js); nothing to do here.
export const onServiceWorkerUpdateReady = () => {}
